import { render, staticRenderFns } from "./annualEducationPlanDetailOld.vue?vue&type=template&id=62ea403c"
import script from "./annualEducationPlanDetailOld.vue?vue&type=script&lang=js"
export * from "./annualEducationPlanDetailOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62ea403c')) {
      api.createRecord('62ea403c', component.options)
    } else {
      api.reload('62ea403c', component.options)
    }
    module.hot.accept("./annualEducationPlanDetailOld.vue?vue&type=template&id=62ea403c", function () {
      api.rerender('62ea403c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/annualEducationPlanDetailOld.vue"
export default component.exports